import { validationRunner } from '@/flow/validation';

// TODO: At some point we might need to use another field as value other than the literal value
//       for example the value of the checkbox is defined by "checked" prop instead of "value"
export const withValidation = (field, t, props = {}, state = {}) => {
  const { value, validators } = field;

  let isValid = field.isValid;
  let errorMessage;
  if (validators?.length) {
    const validationResult = validationRunner(value, validators, {
      props,
      state,
    });
    isValid = validationResult.isValid;
    errorMessage = validationResult.errorMessage;
  }

  return applyValidationResult(field, t, {
    isValid,
    errorMessage,
  });
};

const applyValidationResult = (field, t, result) => {
  const { isValid, errorMessage } = result;

  const validatedField = {
    ...field,
    isValid,
  };

  // Only apply visual error cues if the field has been touched
  if (field.isTouched) {
    validatedField.extraProps.error = !isValid;
    if (errorMessage) {
      validatedField.label = isValid ? field.label : t(errorMessage);
    }
  }

  return validatedField;
};

export const withValidations = (fields, { t, props = {}, state = {} }) => {
  const target = {};
  Object.entries(fields).forEach(([key, field]) => {
    target[key] = withValidation(field, t, props);
  });
  return target;
};
